import { yLoadAsyncScript } from '../../y/util';
import { $el } from '../elements';
import { UIView } from '../view';

export interface YYoutubePlayer {
    player?: YT.Player;
    canceled?: boolean;
    on_ready: () => void;
}

export namespace $youtube {
    let youtube_promise: Promise<void>;

    export function init() {
        if(!youtube_promise) {
            youtube_promise = yLoadAsyncScript('https://www.youtube.com/iframe_api', 'onYouTubeIframeAPIReady');
        }

        return youtube_promise;
    }

    export interface UIYoutubeOptions {
        link?: string;
        volume_control?: UIView;
        controls?: boolean;
        audio?: boolean;
    }

    export function createPlayer(elem: HTMLElement, id: string, options: UIYoutubeOptions, on_ready: () => void): YYoutubePlayer {
        const player: YYoutubePlayer = { on_ready: on_ready };

        init().then(() => {
            if(player.canceled) return;

            player.player = new YT.Player(elem, {
                host: 'https://www.youtube-nocookie.com',
                videoId: id,
                playerVars: {
                    controls: options.controls ? 1 : 0,
                    loop: 1,
                    rel: 0,
                    showinfo: 0,
                    modestbranding: 1,
                    // playlist: id,
                    origin: window.location.origin,
                    playsinline: 1,
                    enablejsapi: 1
                },
                events: {
                    onReady: player.on_ready,
                    // 'onStateChange': onPlayerStateChange
                }
            } as any);
        });

        return player;
    }

    export function destroyPlayer(player: YYoutubePlayer) {
        if(player.player)
            player.player.destroy();
        else
            player.canceled = true;
    }

    const link_regex = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;

    export function isValidLink(link: string) {
        return link_regex.test(link);
    }

    export function idFromLink(link?: string) {
        if(!link) return undefined;

        if(link.length == 11)
            return link;

        const m = link.match(link_regex);

        if(m && m.length >= 2 && m[1].length == 11)
            return m[1];

        return undefined;
    }

    export class UIYoutubePlayer extends UIView {
        private _player?: YYoutubePlayer;
        private _current_id?: string;
        private _iframe: HTMLElement;

        constructor(options?: UIYoutubeOptions) {
            super('div', 'ui-youtube-player');

            this.ui_add(this._iframe = $el.DIV('r-player'));
            this.play(options);
        }

        play(options: UIYoutubeOptions = {}) {
            const id = $youtube.idFromLink(options.link);
            if(id === this._current_id) return;
            this._current_id = id;

            if(this._player) {
                $youtube.destroyPlayer(this._player);
                this._player = undefined;
            }

            if(id) {
                const player = $youtube.createPlayer(this._iframe, id, options, () => {
                    if(options.audio) {
                        if(options.volume_control)
                            options.volume_control.classList.add('bt-volume-up');
                    } else {
                        if(player.player)
                            player.player.mute();
                        if(options.volume_control)
                            options.volume_control.classList.add('bt-volume-off');
                    }
                });
                this._player = player;
            }
        }
    }
}
